// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"656":"b30758f4","954":"cf3f398a"}[chunkId] + ".chunk.css";
};